module.exports = __webpack_public_path__ + "static/media/chess-bishop-alt.583b0487.svg";